import { Link } from 'react-router-dom';

export default function NotMatch() {
  return (
    <div>
      404
      <div>
        <Link to="/">Home</Link>
      </div>
    </div>
  );
}
